module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/hand-c52c6234fc6f700833d770d03064fe5d.png";